module.exports = __webpack_public_path__ + "img/view1.0edb0a6c.jpg";